export default {
  title: 'مشتریان',
  newTitle: 'مشتریان جدید',
  installationsListTitle: 'لیست نصب ها',
  returnedOfflineCustomer: 'بازگشت از آفلاین',
  classify: 'دسته‌بندی',
  search: {
    title: 'جستجوی مشتری',
    placeholder: 'جستجوی مشتریان...',
    noResults: 'مشتری‌ای یافت نشد. عبارت دیگری را امتحان کنید.',
    loading: 'در حال جستجو...',
    error: 'خطا در جستجو',
    searchPrompt: 'برای مشاهده جزئیات، مشتری را جستجو کنید',
    customerDetails: 'جزئیات مشتری',
    financial: 'مالی',
    technicalInfo: 'اطلاعات تخنیکی',
    quickActions: 'کویک اکشن',
    fields: {
      balance: 'موجودی',
      currentPackage: 'بسته فعلی',
      packagePrice: 'قیمت بسته',
      serviceStatus: 'وضعیت سرویس',
      startDate: 'تاریخ شروع',
      endDate: 'تاریخ پایان',
      status: 'وضعیت',
      online: 'آنلاین',
      offline: 'آفلاین',
      unknown: 'نامشخص',
      ping: 'پینگ',
      site: 'سایت',
      baseStation: 'ایستگاه پایه',
      ip: 'آی‌پی',
      signal: 'سیگنال',
      signalStrength: 'قدرت سیگنال',
      signalToNoise: 'نسبت سیگنال به نویز (SNR)',
      ccq: 'CCQ',
      usage: 'مصرف',
      bandwidth: 'پهنای باند',
      connectedDevices: 'تعداد دستگاه‌های متصل',
      base: 'بس',
      totalInvoiced: 'مجموع فاکتورها',
      totalBalance: 'موجودی کل',
      paidInvoices: 'فاکتورهای پرداخت شده',
      unpaidInvoices: 'فاکتورهای پرداخت نشده',
      deltaSibBalance: 'موجودی دلتاسیب',
      lastPayment: 'آخرین پرداخت',
      quickbooksSummary: 'خلاصه QuickBooks',
      deltaSibService: 'سرویس دلتاسیب',
      deltaSibPayments: 'پرداخت‌های دلتاسیب',
      service: 'سرویس',
      description: 'توضیحات',
      price: 'قیمت',
      type: 'نوع',
      paymentStatus: 'وضعیت پرداخت',
      paid: 'پرداخت شده',
      unpaid: 'پرداخت نشده',
      summary: 'تلخص',
      used: 'استفاده شده',
      remaining: 'باقی مانده'
    },
    actions: {
      resetDevice: 'ریبوت دستگاه',
      temporaryActivation: 'فعال کردن موقت',
      changePackage: 'تغییر بسته',
      addExtraVolume: 'افزودن حجم اضافی',
      addExtraTime: 'افزودن تایم اضافی',
      printReceipt: 'چاپ بسته قبلی',
      addToProblemList: 'افزودن به لیست حل مشکل',
      configureRouter: 'تنظیم روتر',
      increaseSpeed: 'افزایش سرعت',
      scheduleContact: 'تنظیم کار تماس',
      customerVisit: 'ویزیت مشتری',
      supportFeedback: 'فیدبک تیم ساپورت',
      comingSoon: 'به زودی',
      notImplemented: 'این عمل در حال حاضر فقط نمایشی است'
    },
    static: 'ثابت (در انتظار داده)',
    notAvailable: 'در دسترس نیست',
    currentService: 'سرویس فعلی',
    balanceSummary: 'خلاصه موجودی',
    usageUsed: 'استفاده شده',
    usageExpired: 'منقضی شده',
    days: 'روز',
    unlimited: 'نامحدود',
    totalData: 'مجموع',
    daysRemaining: 'روزهای باقیمانده'
  },
  manage: {
    title: 'مدیریت مشتری',
    steps: {
      customer: 'مشتری',
      devices: 'تجهیزات',
      assign: 'تخصیص',
      installation: 'نصب'
    },
    form: {
      save: 'ذخیره مشتری',
      submit: 'ثبت',
      approve: 'تایید',
      reject: 'رد',
      submitInstallation: 'ثبت فرم نصب'
    },
    accessDenied: 'دسترسی غیرمجاز'
  },
  form: {
    title: 'فرم مشتری',
    contractId: 'شناسه قرارداد',
    refreshContractId: 'به‌روزرسانی شناسه',
    nameFa: 'نام (فارسی)',
    lastNameFa: 'نام خانوادگی (فارسی)',
    displayName: 'نام نمایشی',
    nameFaPlaceholder: 'نام به فارسی',
    lastNameFaPlaceholder: 'نام خانوادگی به فارسی',
    displayNamePlaceholder: 'نام نمایشی را وارد کنید',
    class: 'کلاس',
    location: 'مکان',
    selectClass: 'انتخاب کلاس (اختیاری)',
    selectLocation: 'انتخاب مکان (اختیاری)',
    noClass: '— بدون کلاس —',
    noLocation: '— بدون مکان —',
    selectStatus: 'انتخاب وضعیت',
    customerType: 'نوع مشتری',
    individual: 'شخصی',
    business: 'تجاری',
    username: 'نام کاربری',
    password: 'رمز عبور',
    date: 'تاریخ',
    companyName: 'نام شرکت',
    activity: 'فعالیت',
    name: 'نام',
    lastName: 'نام خانوادگی',
    email: 'ایمیل',
    licenseNo: 'شماره مجوز',
    nid: 'کد ملی (اختیاری)',
    address: 'آدرس',
    devices: 'دیوایس',
    visp: 'VISP',
    selectVisp: 'انتخاب VISP',
    center: 'مرکز',
    selectCenter: 'انتخاب مرکز',
    reseller: 'Reseller',
    branch: 'نمایندگی',
    selectBranch: 'انتخاب نمایندگی',
    customerStatus: 'وضعیت مشتری',
    demo: 'آزمایشی',
    final: 'نهایی',
    errors: {
      serviceRequired: 'لطفا قبل از ثبت یک بسته سرویس انتخاب کنید'
    },
    phone: 'تلفن',
    phonePlaceholder: 'شماره تلفن را وارد کنید',
    mobile: 'موبایل',
    mobilePlaceholder: 'شماره موبایل را وارد کنید',
    note: 'یادداشت قرارداد',
    notePlaceholder: 'حداکثر ۱۰۰ کاراکتر',
    phones: {
      title: 'شماره‌های تماس',
      add: 'افزودن شماره تما',
      placeholder: 'شماره تماس را وارد کنید'
    },
    package: 'بسته',
    discountCommentLabel: 'یادداشت تخفیف',
    isPrinted: 'قرارداد چاپ شده',
    isSigned: 'قرارداد امضا شده',
    selectPackage: 'انتخاب بسته',
    searchPackages: 'جستجوی بسته ها...',
    customFields: {
      title: 'فیلدهای سفارشی',
      add: 'افزودن فیلد سفارشی',
      key: 'کلید را وارد کنید',
      value: 'مقدار را وارد کنید'
    },
    submit: 'ذخیره مشتری',
    saveAndPrint: 'ذخیره و چاپ',
    selectDate: 'انتخاب تاریخ',
    selectCustomerType: 'انتخاب نوع مشتری',
    usernamePlaceholder: "name{'@'}family",
    companyNamePlaceholder: 'نام شرکت را وارد کنید',
    activityPlaceholder: 'فعالیت تجاری را وارد کنید',
    namePlaceholder: 'نام را وارد کنید',
    lastNamePlaceholder: 'نام خانوادگی را وارد کنید',
    emailPlaceholder: 'آدرس ایمیل را وارد کنید',
    licenseNoPlaceholder: 'شماره مجوز را وارد کنید',
    nidPlaceholder: 'کد ملی را وارد کنید',
    addressPlaceholder: 'آدرس را وارد کنید',
    internetUsage: {
      title: 'آیا قبلاً اینترنت وایرلس داشته‌اید؟',
      yes: 'بله',
      ispName: 'از کدام ISP',
      ispNamePlaceholder: 'نام ISP را وارد کنید'
    },
    internetPurpose: {
      title: 'چرا از اینترنت استفاده می‌کنید؟',
      placeholder: 'هدف استفاده از اینترنت را انتخاب کنید',
      homeUse: 'برای استفاده خانگی',
      onlineGaming: 'بازی های آنلاین',
      business: 'برای کسب و کار',
      exchange: 'صرافی',
      travelAgency: 'شرکت های سیاحتی'
    },
    findUs: {
      title: 'چگونه با FR-ISP آشنا شدید؟',
      placeholder: 'نحوه آشنایی را انتخاب کنید',
      brochure: 'بروشور',
      marketer: 'مارکیتر',
      socialMedia: 'سوشیا میدیا',
      billboard: 'بیلبورد',
      customerReferral: 'معرفی توسط مشتری',
      farsroute: 'فارس‌روت',
      tvAds: 'تبلیغات تلویزیونی',
      sms: 'SMS',
      whatsapp: 'پیام واتساپ'
    },
    previousPackage: {
      title: 'پکیج قبلی',
      placeholder: 'پکیج قبلی را انتخاب کنید',
      dedicated: 'نامحدود',
      dedicatedCombined: 'نامحدود ترکیبی',
      dedicatedDaily: 'نامحدود روزانه',
      volumeShortTerm: 'حجمی کوتاه مدت',
      volumeLongTerm: 'حجمی بلند مدت',
      volumeDailyLimited: 'حجمی روزانه محدود'
    },
    terminationReasons: {
      title: 'دلایل قطع سرویس',
      placeholder: 'دلیل قطع سرویس را انتخاب کنید',
      price: 'قیمت',
      quality: 'کیفیت',
      customerService: 'خدمات مشتری',
      speed: 'سرعت',
      relocation: 'جابجایی',
      other: 'سایر'
    },
    selectCustomer: 'انتخاب مشتری',
    searchCustomer: 'جستجوی مشتریان...'
  },
  service: {
    table: {
      name: 'نام سرویس',
      serviceId: 'شناسه سرویس',
      price: 'قیمت',
      discount: 'تخفیف',
      discountTypeColumn: 'نوع تخفیف',
      discountScopeColumn: 'دامنه تخفیف',
      discountValueColumn: 'مقدار تخفیف',
      finalPrice: 'قیمت نهایی'
    },
    discountType: {
      amount: 'مبلغ تخفیف',
      percent: 'درصد تخفیف'
    },
    dropdown: {
      idLabel: 'شناسه'
    }
  },
  devices: {
    title: 'تجهیزات',
    customerHasOwnDevice: 'مشتری تجهیزات از قبل دارد (بدون فروش تجهیز)',
    provision: {
      sold: 'خریداری شده',
      leased: 'قرضی / لیزینگ'
    },
    add: 'افزودن تجهیزات',
    addAnotherLine: 'برای افزودن سطر جدید، دستگاه را از لیست انتخاب کنید.',
    emptyLineHint: 'برای افزودن کلیک کنید',
    cancelNewLine: 'انصراف',
    selectDevice: 'انتخاب تجهیزات',
    searchDevices: 'جستجوی تجهیزات...',
    table: {
      name: 'دستگاه',
      sku: 'SKU',
      description: 'توضیحات',
      unit: 'واحد',
      unitPrice: 'قیمت واحد',
      price: 'قیمت',
      quantity: 'تعداد',
      lineTotal: 'جمع سطر',
      provision: 'ارایه'
    },
    totalAmount: 'مبلغ کل',
    submit: 'ثبت'
  },
  installation: {
    title: 'نصب',
    form: {
      date: 'تاریخ',
      selectDate: 'انتخاب تاریخ',
      type: 'نوع',
      types: {
        installation: 'نصب',
        troubleshooting: 'عیب‌یابی'
      },
      status: {
        title: 'وضعیت',
        pending: 'در انتظار',
        inProgress: 'در حال انجام',
        done: 'انجام شده',
        failed: 'ناموفق'
      },
      jobDetails: 'جزئیات کار',
      contractPackage: 'بسته قرارداد (فروش)',
      installedPackage: 'بسته نصب‌شده',
      selectPackage: 'انتخاب بسته',
      deviceSource: 'منبع تجهیزات',
      selectDeviceSource: 'انتخاب منبع تجهیزات',
      linkPerformance: 'عملکرد لینک',
      customerInfo: {
        name: 'نام مشتری',
        phone: 'تلفن',
        mobile: 'موبایل',
        address: 'آدرس'
      },
      details: {
        site: 'سایت',
        sitePlaceholder: 'موقعیت سایت / دکل',
        signalStrength: 'قدرت سیگنال',
        signalStrengthPlaceholder: 'مثال: 60-',
        signalToNoise: 'نسبت سیگنال به نویز (SNR)',
        signalToNoisePlaceholder: 'مثال: 30',
        signal: 'سیگنال',
        ccq: 'CCQ',
        ccqPlaceholder: 'مثال: 95',
        base: 'پایه',
        cable: 'کابل',
        router: 'روتر',
        antenna: 'آنتن',
        note: 'یادداشت',
        cancelReason: 'دلیل لغو'
      },
      actions: {
        approve: 'تایید',
        reject: 'رد',
        submit: 'ثبت فرم '
      },
      drawer: {
        title: 'جزئیات نصب',
        description: 'گزارش میدانی این مشتری',
        deviceSource: 'منبع تجهیزات',
        approved: 'تأیید شده',
        jobNumber: 'شماره کار',
        openForm: 'باز کردن فرم نصب',
        loading: 'در حال بارگذاری نصب…',
        noInstallation: 'اطلاعات نصب موجود نیست',
        loadError: 'بارگذاری جزئیات نصب انجام نشد.',
        close: 'بستن',
        installerDetails: 'نصاب',
        installerName: 'نام',
        installerEmail: 'ایمیل',
        installerBranch: 'شعبه',
        taskStatus: 'وضعیت تسک',
        assignedAt: 'تاریخ تخصیص',
        notAssigned: 'هنوز نصابی تخصیص داده نشده',
      }
    }
  },
  filter: {
    all: 'همه',
    individual: 'شخصی',
    business: 'تجاری'
  },
  actions: {
    add: 'افزودن مشتری',
    edit: 'ویرایش',
    delete: 'حذف',
    view: 'مشاهده',
    menu: 'باز کردن منو',
    title: 'عملیات',
    copyId: 'کپی شناسه مشتری',
  },
  drawer: {
    printContract: 'چاپ قرارداد',
  },
  columns: {
    id: 'آیدی',
    name: 'نام',
    licenseOrNID: 'شماره مجوز / کد ملی',
    email: 'ایمیل',
    address: 'آدرس',
    phones: 'شماره‌های تماس',
    fields: 'فیلدها',
    devices: 'تجهیزات',
    noPhone: 'بدون شماره تماس',
    noFields: 'بدون فیلد',
    noDevices: 'بدون تجهیزات',
    deviceCount: '{count} تجهیز',
    installationStatus: 'وضعیت نصب'
  },
  notifications: {
    customerUpdated: 'اطلاعات {name} با موفقیت به‌روزرسانی شد!',
    customerAdded: '{name} با موفقیت به عنوان مشتری اضافه شد!',
    deviceUpdated: 'تجهیزات با موفقیت به‌روزرسانی شدند!',
    installationUpdated: 'نصب با موفقیت به‌روزرسانی شد!',
    usernameExists: 'این نام کاربری قبلاً گرفته شده است. لطفاً نام کاربری دیگری انتخاب کنید.',
    processFailed: 'پردازش مشتری با خطا مواجه شد.',
    deviceUpdateFailed: 'به‌روزرسانی تجهیزات {name} با خطا مواجه شد.',
    installationFailed: 'ثبت نصب برای {name} با خطا مواجه شد.',
    idCopied: 'شناسه مشتری در کلیپ‌بورد کپی شد',
    customerDeleted: '{name} با موفقیت حذف شد',
    deleteFailed: 'حذف مشتری با خطا مواجه شد. لطفاً دوباره تلاش کنید.',
    statusUpdated: 'وضعیت {name} با موفقیت به‌روزرسانی شد!',
    statusUpdateFailed: 'به‌روزرسانی وضعیت مشتری با خطا مواجه شد. لطفاً دوباره تلاش کنید.',
  },
  common: {
    success: 'موفقیت',
    error: 'خطا',
    loading: 'در حال بارگذاری...',
    submitting: 'در حال ارسال...',
    customer: 'مشتری',
    optional: 'اختیاری'
  },
  roles: {
    admin: 'مدیر',
    noc: 'ناک',
    installer: 'وظایف'
  },
  dialog: {
    errors: {
      title: 'خطا',
      noPhone: 'شماره تلفن الزامی است',
      phoneRequired: 'لطفا قبل از ثبت حداقل یک شماره تلفن وارد کنید'
    },
    success: {
      title: 'موفقیت',
      customerAdded: 'مشتری با موفقیت اضافه شد',
      customerUpdated: 'مشتری با موفقیت بروزرسانی شد'
    }
  },
  syncDrawer: {
    title: 'ویرایش و همگام‌سازی مشتری',
    badge: 'موتور همگام‌سازی V2',
    description: 'همگام‌سازی زنده دوطرفه با سیب و کوئیک‌بوکس — منبع دریافت: سیب/کوئیک‌بوکس | منبع ویرایش: CRM',
    checkInSibAndQbo: 'بررسی در سیب و کوئیک‌بوکس',
    printContract: 'چاپ قرارداد',
    syncStatusTitle: 'وضعیت همگام‌سازی سیستم‌ها (DeltaSIB و QuickBooks)',
    clickCheckToVerify: 'برای بررسی همگام‌سازی زنده روی دکمه "بررسی در سیب و کوئیک‌بوکس" کلیک کنید',
    checkingSystems: 'در حال بررسی سیستم‌های DeltaSIB و QuickBooks...',
    activeMismatches: '{count} مورد عدم تطابق فعال',
    allSynced: 'تمام سیستم‌ها کاملاً همگام هستند',
    autoSyncUponSave: 'همگام‌سازی خودکار به هنگام ذخیره',
    statusSynced: 'همگام',
    statusActionNeeded: 'نیاز به اقدام',
    statusNeedsSync: 'نیاز به همگام‌سازی',
    statusUnlinked: 'لینک نشده',
    needsSync: 'نیاز به همگام‌سازی',
    synced: 'همگام',
    autoSyncOnSave: 'همگام‌سازی خودکار هنگام ذخیره',
    applyCrmValues: 'اعمال مقادیر CRM',
    correctInCrm: 'اصلاح در CRM',
    reMatch: 'تطبیق',
    mismatchQuestion: 'مغایرت دارد. کدام مقدار درست است؟',
    applyCrmToSystem: 'مقدار CRM را در {system} اعمال کن',
    applySystemToCrm: 'مقدار {system} را در CRM اعمال کن',
    applySibToQbo: 'اعمال مقدار SIB در QuickBooks',
    applyDeltaToBoth: 'اعمال مقدار DeltaSIB در CRM و QBO',
    unlinkedWarning: 'شناسه‌ای برای این مشتری یافت نشد. همگام‌سازی تا تطبیق مجدد متوقف است.',
    noMismatches: 'همه سیستم‌ها همگام هستند',
    applyCrmToAllSystems: 'اعمال مقادیر CRM روی همهٔ سیستم‌های لینک‌شده',
    applyCrmToAllNotice: 'فیلدهایی که منبعشان سیستم دیگری است (مثل نام کاربری) تغییر نمی‌کنند',
    pushCrmToSib: 'ارسال CRM به سیب',
    pushCrmToQbo: 'ارسال CRM به کوئیک‌بوکس',
    changeMatch: 'تغییر تطبیق',
    findMatch: 'پیدا کردن تطبیق',
    hideDetails: 'مخفی‌سازی جزئیات',
    systemDetails: 'جزئیات سیستم‌ها',
    deltaSibUnlinkedBanner: 'هیچ حساب DeltaSIB متصل شده‌ای یافت نشد.',
    qboUnlinkedBanner: 'مشتری در QuickBooks متصل نیست. صدور فاکتور متوقف است.',
    sourceDeltaSib: 'منبع: DeltaSIB',
    sibValueChanged: 'مقدار {field} در سیب تغییر کرده است:',
    updateInCrm: 'بروزرسانی {field} در CRM و QBO',
    mismatchBetween: 'مغایرت در {field} ({system})',
    mismatchPrompt: 'مقدار این فیلد در سیستم‌ها متفاوت است. مشخص کنید کدام مقدار اعمال شود:',
    currentCrmValue: 'مقدار فعلی در CRM',
    remoteLiveValue: 'مقدار زنده در {system}',
    overwriteRemote: '➔ ارسال این مقدار به {system}',
    applyToCrm: '➔ اعمال این مقدار در CRM',
    allDataSynced: 'تمام اطلاعات مشتری در سیب و کوئیک‌بوکس کاملاً همگام است',
    applyAll: 'اعمال تمام مقادیر زنده در CRM',
    applyAllSubtitle: 'بروزرسانی تمام اطلاعات مشتری در CRM با داده‌های زنده سیب و کوئیک‌بوکس',
    applyAllNotice: 'فیلدهای اختصاصی سیب (مانند نام کاربری) بدون بازنویسی در CRM و QBO اعمال می‌شوند',
    pendingEdits: '{count} تغییر ثبت‌نشده در فرم CRM:',
    saveAndPush: 'ذخیره و ارسال به سیب / کوئیک‌بوکس',
    contractPrinted: 'قرارداد چاپ شده',
    contractSigned: 'قرارداد امضا شده',
    printed: 'چاپ شد',
    signed: 'امضا شد',
    crmInfoTitle: 'اطلاعات مشتری در CRM',
    crmInfoSubtitle: 'منبع اصلی ویرایش: CRM — تغییرات به سیب و کوئیک‌بوکس ارسال خواهند شد',
    customerType: 'نوع مشتری',
    individual: 'شخصی',
    business: 'شرکتی',
    registrationDate: 'تاریخ ثبت',
    customerStatus: 'وضعیت مشتری',
    selectStatus: 'انتخاب وضعیت',
    billingCategory: 'دسته‌بندی مالی',
    selectCategory: 'انتخاب دسته‌بندی',
    contractId: 'شناسه قرارداد',
    username: 'نام کاربری',
    usernameLockedTooltip: 'این فیلد مختص DeltaSIB بوده و در CRM قفل است',
    nameFa: 'نام (فارسی/دری)',
    lastNameFa: 'تخلص / نام خانوادگی (فارسی/دری)',
    nameEn: 'نام (انگلیسی)',
    lastNameEn: 'نام خانوادگی (انگلیسی)',
    displayName: 'نام نمایشی (در QBO و سیستم‌ها)',
    mobile: 'شماره موبایل',
    phone: 'تلفن ثابت',
    email: 'ایمیل',
    paymentTerms: 'شرایط پرداخت',
    address: 'آدرس کامل',
    companyName: 'نام شرکت',
    licenseNo: 'شماره جواز / لایسنس',
    allSystemsSynced: 'تمامی سیستم‌ها همگام هستند',
    itemsPendingSync: '{count} مورد در انتظار همگام‌سازی',
    cancel: 'انصراف',
    saveAndSync: 'ذخیره و همگام‌سازی',
    saving: 'در حال ذخیره...',
    matchModalTitle: 'اتصال مشتری با {system}',
    matchModalDescription: 'جستجو بر اساس نام، شناسه یا شماره تلفن در {system}',
    searchPlaceholder: 'جستجو بر اساس نام، شناسه، تلفن، نام کاربری...',
    noMatchFound: 'موردی یافت نشد',
    link: 'اتصال',
    close: 'بستن',
    confirmModalTitle: 'تأیید ذخیره و ارسال تغییرات',
    confirmModalDescription: 'تغییرات زیر در CRM ذخیره شده و به سیستم‌های متصل ارسال خواهند شد:',
    modifiedFields: 'فیلدهای ویرایش‌شده:',
    noManualEdits: 'هیچ فیلدی به صورت دستی ویرایش نشده است — همگام‌سازی کلی انجام خواهد شد.',
    targetSystems: 'سیستم‌های مقصد جهت ارسال:',
    backToEditing: 'بازگشت به ویرایش',
    confirmAndSave: 'تأیید و ذخیره',
    fields: {
      name: 'نام (انگلیسی)',
      lastName: 'تخلص (انگلیسی)',
      nameFa: 'نام (فارسی)',
      lastNameFa: 'تخلص (فارسی)',
      displayName: 'نام نمایشی',
      email: 'ایمیل',
      phone: 'تلفن ثابت',
      mobile: 'شماره موبایل',
      address: 'آدرس',
      contractId: 'شناسه قرارداد',
      username: 'نام کاربری',
      companyName: 'نام شرکت',
      licenseNo: 'شماره جواز'
    }
  }
} 